import { useEffect, useState } from 'react';

type Props = {
  /** 0–1 */
  ratio: number;
  className?: string;
  delayMs?: number;
  ariaLabel?: string;
};

/**
 * Balk die breedte animeert (respecteert prefers-reduced-motion via CSS).
 */
export function AnimatedBar({ ratio, className, delayMs = 0, ariaLabel }: Props) {
  const [w, setW] = useState(0);
  const pct = Math.min(100, Math.max(0, ratio * 100));

  useEffect(() => {
    const t = window.setTimeout(() => setW(pct), delayMs);
    return () => window.clearTimeout(t);
  }, [pct, delayMs]);

  return (
    <div
      className="h-2.5 overflow-hidden rounded-full bg-ct-border sm:h-3"
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
    >
      <div
        className={`ct-bar-inner h-full rounded-full ${className ?? ''}`}
        style={{ width: `${w}%` }}
      />
    </div>
  );
}
